import React from "react";
import { HashRouter, Switch, Route, Redirect } from "react-router-dom";
import MultiStepForm from "./components/MultiStepForm";
import Header from "./components/Header";
import Footer from './components/Footer/index'
function App() {
  return (
    <React.Fragment>
      <HashRouter>
        <Header />
        <Switch>
          <Route path="/" exact render={() => <Redirect to="/start" />} />
          <Route path="/start" component={MultiStepForm} />
        </Switch>
        <Footer/>
      </HashRouter>
    </React.Fragment>
  );
}

export default App;
